import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

const nrCopies: ReadonlyArray<ItemVM> = Object.freeze([
  {
    id: '1',
    value: '1',
  },
  {
    id: '2',
    value: '2',
  },
  {
    id: '3',
    value: '3',
  },
  {
    id: '4',
    value: '4',
  },
  {
    id: '5',
    value: '5',
  },
  {
    id: '6',
    value: '6',
  },
  {
    id: '7',
    value: '7',
  },
  {
    id: '8',
    value: '8',
  },
  {
    id: '9',
    value: '9',
  },
  {
    id: '10',
    value: '10',
  },
]);

interface NumberCopiesSelectProps {
  value?: string;
  onChange: (item: string) => void;
  disabled?: boolean;
}

const NumberCopiesSelectComponent = ({
  value,
  onChange,
  disabled = false,
}: NumberCopiesSelectProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel id={`id-select-copies`}>Numero Copie</InputLabel>
      <PmiSelect
        labelId={`label-select-copies`}
        id={`id-select-copies`}
        name={`id-select-copies`}
        value={value}
        label={'Numero Copie'}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
      >
        {nrCopies.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

NumberCopiesSelectComponent.displayName = 'Number Copies Select';

const NumberCopiesSelect = memo(NumberCopiesSelectComponent);

export default NumberCopiesSelect;
